import "error-polyfill";
import { raisso } from './raisso.js';
import { profileManager } from './profile-manager.js';
import { settingsManager } from './settings-manager';

window.Rai = window.Rai ?? {} as typeof window.Rai;
window.Rai.Raisso = raisso;
window.Rai.ProfileManager = profileManager;
window.Rai.SettingsManager = settingsManager;

const params = new URLSearchParams(location.search);
const isWebView = params.has('webview');
if (!isWebView) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(window as any).onGigyaServiceReady = function() {
		profileManager.checkGigyaLogin()
	};

	(function initGigya() {
    if (!window || !document) { return }
    if (window.gigya?.isGigya) { return }
    const scripts = document.querySelectorAll('script');
    for (const scr of scripts) {
      if (/.*\.gigya\.com\/js\/socialize\.js\?/.test(scr.src)) {
        scr.addEventListener('error', () => {
          const errorDiv = document.createElement('div');
          errorDiv.setAttribute('style', 'padding: 0.5rem; background-color: rgba(255, 0, 0, .7); color: white; display: flex; justify-content: center;');
          const par = document.createElement('p');
          par.innerHTML = `Attenzione, per problemi diconnettività o per la presenza di qualche plugin di offuscamento
            il browser non riesce a scaricare le librerie necessarie per la login sul sito.<br>
            Ti invitiamo a disabilitare adblock e plugin simili e riprovare.`
          errorDiv.appendChild(par);

          let el = document.querySelector('#main-header');
          if (!el) {
            el = document.body;
          }
          el.prepend(errorDiv);
        });
        break;
      }
    }
  })()
}

export type { Raisso, RaissoError } from "./raisso.js"
export type { RaiSsoProfileManager } from "./profile-manager.js"
export type { RaiSsoProfile } from "./profile.js";
export type { RaiSsoSettingsManager } from './settings-manager';
export * from "./controllers/service-models.js";
